var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import WalkHelper from "../../helper/WalkHelper.js";
const countChildren = (parent) => {
  var _a, _b;
  return (_b = (_a = parent.children) == null ? void 0 : _a.reduce((sum, child) => {
    var _a2;
    return sum + ((_a2 = child.remoteChildCount) != null ? _a2 : 0) + 1;
  }, 0)) != null ? _b : 0;
}, isFullyLoaded = (parent) => countChildren(parent) >= parent.remoteChildCount;
var TreeStoreLazyLoadPlugin_default = (Target) => {
  var _a;
  return _a = class extends Target {
    static get pluginConfig() {
      var _a2, _b;
      const config = {};
      for (const prop in super.pluginConfig) {
        config[prop] = [...super.pluginConfig[prop]];
      }
      config.override = (_a2 = config.override) != null ? _a2 : [];
      config.override.push("loadChildren", "getAt");
      const lazyGetAt = (_b = config.assign) == null ? void 0 : _b.indexOf("lazyGetAt");
      if (lazyGetAt >= 0) {
        config.assign.splice(lazyGetAt, 1);
      }
      return config;
    }
    constructor() {
      super(...arguments);
      this.totalCount = 0;
    }
    // Need to overwrite default load, because it expects a promise
    load() {
      const me = this, { rootNode } = me.client, queue = me.loadQueue[rootNode.id];
      if (!queue) {
        return me.doLazyLoad({ parent: rootNode, startIndex: 0 });
      } else if (queue === true) {
        me.clearLoaded();
        return me.load();
      } else {
        return queue;
      }
    }
    // Updates a parent's remoteChildCount by adding the specified amount
    // Also updates the parent's parents the whole way up to the rootNode
    changeRemoteChildCount(records, amount, affectedParents) {
      var _a2;
      if (records == null ? void 0 : records.length) {
        const parents = records.map((r) => {
          var _a3, _b, _c;
          return (_c = r.parent) != null ? _c : this.client.getById((_b = r.parentId) != null ? _b : (_a3 = r.originalData) == null ? void 0 : _a3.parentId);
        });
        while (parents.length) {
          const parent = parents.shift();
          if (parent) {
            if (!parent.isRoot) {
              parents.push(parent.parent);
            }
            parent.remoteChildCount = (_a2 = parent.remoteChildCount ? parent.remoteChildCount + amount : parent.children.length) != null ? _a2 : 0;
            affectedParents.add(parent);
          }
        }
      }
    }
    // When a record is added or removed
    internalOnCommit({ changes }) {
      super.internalOnCommit();
      const affectedParents = /* @__PURE__ */ new Set();
      this.changeRemoteChildCount(changes.added, 1, affectedParents);
      this.changeRemoteChildCount(changes.removed, -1, affectedParents);
      affectedParents.forEach((parent) => {
        this.loadQueue[parent.id] = isFullyLoaded(parent);
      });
    }
    // Implementing the load on demand function
    loadChildren(parent) {
      return this.doLazyLoad({ parent, startIndex: 0 });
    }
    // Overrides store default getAt
    getAt(index) {
      var _a2;
      const me = this, { loadQueue, client } = me, record = client.records[index];
      if (record) {
        const { parent } = record;
        if (record.expanded && record.remoteChildCount > 0 && !((_a2 = record.children) == null ? void 0 : _a2.length) && !loadQueue[record.id]) {
          me.doLazyLoad({ parent: record, startIndex: 0 });
        }
        if (record === parent.lastChild && !loadQueue[parent.id]) {
          me.doLazyLoad({ startIndex: record.parentIndex + 1, parent });
        }
      }
      return record;
    }
    async doLazyLoad({ parent, ...params }) {
      var _a2;
      const me = this, { loadQueue, client } = me, { id } = parent;
      parent.instanceMeta(client).isLoadingChildren = true;
      me.triggerLazyLoadStart(arguments[0]);
      loadQueue[id] = client.requestData({
        ...params,
        parentId: parent.isRoot ? "root" : id,
        count: me.chunkSize
      });
      const {
        [me.totalCountProperty]: totalCount,
        [me.dataProperty]: data
      } = await loadQueue[id];
      if (parent.isRoot && totalCount >= 0) {
        parent.remoteChildCount = totalCount;
      }
      me.addData(data, parent);
      me.totalCount = client.count;
      loadQueue[id] = isFullyLoaded(parent);
      if (!me.isLoading) {
        (_a2 = client.trigger) == null ? void 0 : _a2.call(client, "refresh", { action: "lazyload" });
      }
      me.triggerLazyLoadEnd(arguments[0], data);
      parent.instanceMeta(client).isLoadingChildren = false;
      ;
    }
    addData(data, parent) {
      const { client, loadQueue } = this;
      WalkHelper.preWalk({ children: data }, ({ children }) => (children == null ? void 0 : children.length) ? children : null, (record) => {
        const { id, children } = record;
        if (id && record.remoteChildCount > 0) {
          if (record.expanded === false && !(children == null ? void 0 : children.length)) {
            record.children = true;
          } else if ((children == null ? void 0 : children.length) && !loadQueue[id] && isFullyLoaded(record)) {
            loadQueue[id] = true;
          } else if (!children) {
            record.children = [];
          }
        }
      });
      if (!client.modelClass.fieldMap.remoteChildCount) {
        client.modelClass.addField("remoteChildCount");
      }
      parent.appendChild(data, true);
      client.added.clear();
    }
    // getCollapsedChildCount(toIndex) {
    //     return this.client.getRange(0, toIndex).filter(r => !r.isExpanded(this.client)).reduce((sum, cur) => sum += cur.childCount || 0, 0);
    // }
    //
    // translateIndex(index, reverse) {
    //     return index + this.getCollapsedChildCount(index) * (reverse ? -1 : 1);
    // }
    //
    // // When estimating a total count, we need to add the collapsed records
    // setEstimatedTotalCount(count) {
    //     this.totalCount = this.translateIndex(count);
    // }
    //
    // // When fetching from storage with a translated index, we need to translate it back first
    // getFromStorage(index) {
    //     return super.getFromStorage(this.translateIndex(index, true));
    // }
  }, __publicField(_a, "$name", "TreeStoreLazyLoadPlugin"), __publicField(_a, "configurable", {
    chunkSize: 50
  }), _a;
};
export {
  TreeStoreLazyLoadPlugin_default as default
};
